import { Placement } from '../internal/WixUiCoreComponents/components/CorePopover';
import {
  ArrowRightIcon,
  ArrowLeftIcon,
  ArrowTopIcon,
  ArrowBottomIcon,
} from './ArrowIcon';

export function getArrowByPlacement(placement: Placement): React.ComponentType {
  if (placement.indexOf('top') === 0) {
    return ArrowTopIcon;
  }

  if (placement.indexOf('bottom') === 0) {
    return ArrowBottomIcon;
  }

  if (placement.indexOf('left') === 0) {
    return ArrowLeftIcon;
  }

  if (placement.indexOf('right') === 0) {
    return ArrowRightIcon;
  }

  return undefined;
}

export { ArrowBottomIcon, ArrowTopIcon, ArrowLeftIcon, ArrowRightIcon };
